export type Locale = {
  name: string;
  months: Array<string[]>;
  weekDays: Array<string[]>;
  digits: string[];
  meridiems: Array<string[]>;
};

export const locale_da: Locale = {
  name: "da",
  months: [
    ["januar", "jan"],
    ["februar", "feb"],
    ["marts", "mar"],
    ["april", "apr"],
    ["maj", "maj"],
    ["juni", "jun"],
    ["juli", "jul"],
    ["august", "aug"],
    ["september", "sep"],
    ["oktober", "okt"],
    ["november", "nov"],
    ["december", "dec"],
  ],
  weekDays: [
    ["søndag", "søn"],
    ["mandag", "man"],
    ["tirsdag", "tir"],
    ["onsdag", "ons"],
    ["torsdag", "tor"],
    ["fredag", "fre"],
    ["lørdag", "lør"],
  ],
  digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  meridiems: [
    ["AM", "am"],
    ["PM", "pm"],
  ],
};
